import { FrostFreeStatus } from "@eisox/api/core-api";
import { z } from "@eisox/zod";

import { periodsSchema } from "~/features/frost-free";

export const holidaysSettingsSchema = z.object({
  mode: z.enum(FrostFreeStatus),
  frostFreePeriods: periodsSchema,
});

export type HolidaysSettingsSchemaType = z.infer<typeof holidaysSettingsSchema>;
